import { lazy, Suspense } from "react";

const LazyRouter: React.FC<{ load: () => Promise<{ default: React.FC }> }> = ({ load }) => {
    const Component = lazy(load);
    return (
        <Suspense>
            <Component />
        </Suspense>
    )
}

export default LazyRouter;